module.exports = __webpack_public_path__ + "static/media/calendar.f7e7bc01.svg";